module.exports = __webpack_public_path__ + "img/app_thumbnail-400x300.cebff741.jpg";